var _circle, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 119,
    viewBox: "0 0 119 119",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 59.5,
    cy: 59.5,
    r: 59.5,
    fill: "#FF9F1A",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M65.5542 39.7891L64.3481 71.6226H56.1914L54.9854 39.7891H65.5542ZM54.6997 81.4932C54.6997 80.0755 55.2075 78.88 56.2231 77.9067C57.2388 76.9334 58.5824 76.4468 60.2539 76.4468C61.9043 76.4468 63.2267 76.9334 64.2212 77.9067C65.2368 78.88 65.7446 80.0755 65.7446 81.4932C65.7446 82.932 65.2368 84.138 64.2212 85.1113C63.2267 86.0635 61.9043 86.5396 60.2539 86.5396C58.5824 86.5396 57.2388 86.0635 56.2231 85.1113C55.2075 84.138 54.6997 82.932 54.6997 81.4932Z",
    fill: "#FF9F1A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarning);
export default __webpack_public_path__ + "static/media/warning.f647905536b00313b6742b7b0c55d7ae.svg";
export { ForwardRef as ReactComponent };